module.exports = __webpack_public_path__ + "media/images/icons/delete-f22dd3096fe86539a1cb7bc6baac7f20.svg";